import Link from 'next/link';
import { forwardRef } from 'react';

function isValidUrl(url: string) {
    try {
        new URL(url);
        return true;
    } catch {
        return false;
    }
}

interface Props extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
    href?: string | undefined;
    children: React.ReactNode;
}

const FancyLink = forwardRef<HTMLAnchorElement, Props>(({ href, children, ...props }, ref) => {
    if (!href) {
        return <div className={props.className}>{children}</div>;
    }

    if (isValidUrl(href)) {
        return (
            <a href={href} ref={ref} target='_blank' {...props}>
                {children}
            </a>
        );
    }

    return (
        <Link href={href} ref={ref} {...props}>
            {children}
        </Link>
    );
});

FancyLink.displayName = 'FancyLink';

export default FancyLink;

